document.addEventListener('DOMContentLoaded', function() {
  // Initialize all slideshows
  document.querySelectorAll('.slideshow').forEach(function(slideshow) {
    const slideContainers = slideshow.querySelectorAll('.slideshow__slide-container');
    const prevButton = slideshow.querySelector('.slideshow__arrow--previous');
    const nextButton = slideshow.querySelector('.slideshow__arrow--next');
    const autoplay = parseInt(slideshow.dataset.autoplay || 0, 10);
    let currentSlide = 0;
    let autoplayInterval;
    
    if (slideContainers.length <= 1) return;
    
    // Function to change slide
    function goToSlide(index) {
      slideContainers.forEach(container => container.classList.remove('active'));
      currentSlide = (index + slideContainers.length) % slideContainers.length;
      slideContainers[currentSlide].classList.add('active');
    }
    
    // Set up click handlers for arrows
    if (prevButton) {
      prevButton.addEventListener('click', function() {
        goToSlide(currentSlide - 1);
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          startAutoplay();
        }
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', function() {
        goToSlide(currentSlide + 1);
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          startAutoplay();
        }
      });
    }
    
    // Set up autoplay if enabled
    function startAutoplay() {
      if (autoplay > 0) {
        autoplayInterval = setInterval(function() {
          goToSlide(currentSlide + 1);
        }, autoplay * 1000);
      }
    }
    
    // Initialize first slide and autoplay
    goToSlide(0);
    startAutoplay();
  });
});